import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import {Router} from '@angular/router';
import {NgForm} from '@angular/forms';
import {FormControl} from '@angular/forms';
import { Location } from '@angular/common';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { DummydataService } from '../../../services/dummydata/dummydata.service';
import {BoardService} from "../../../services/board/board.service";
import {BackendService} from "../../../services/api/backend.service";
import { User, Owner} from '../../../modele/user/userModel';
import {UserSettings} from "../../../modele/user/userSettings";
import {Board, UserRelatedBoard, UserToBoardRelation, BoardIdentifier} from '../../../modele/boardModel';
import {Topic} from "../../../modele/topicModel";
import {EndpointService} from "../../../services/endpoint/endpoint.service"
import * as JsonToXML from "js2xmlparser";
import { Sitemap} from '../../../modele/sitemapModele';



@Component({
  selector: 'app-searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss']
})

export class SearchboxComponent implements OnInit {
    hideRequiredControl = new FormControl(false);
    public value: string = '';
    public charsLeft: number= 0;
    valuelength;
    valuelengthnull: boolean = false;
    searchValue = new FormControl();
    filteredStates: Observable<Board[]>;
    boardLen;
    click: boolean = false;
    _filterLen;
    private boards2:Array<Board>=[];
    private boardsResults:Array<Board>=[];
    noBoardFound: boolean = false;
    sitemap:Array<Sitemap>=[];
    closeAutoComplete: boolean = false;


  constructor(
      private router: Router,
      private _location: Location,
      private logger: NGXLogger,
      private dummydata: DummydataService,
      private bes: BackendService,
      private endpointSrv: EndpointService,


  ) {

      this.endpointSrv.getAllForSearch().subscribe((allboards=>{
          let boardresults = allboards['boards'];
            boardresults.map((boo) => {
                let test = new Sitemap(
                    "https://whooosh.com/"+boo.board_name,
                )
                this.sitemap.push(test)


                let booards = new Board(boo.board_id,
                    boo.board_name,
                    "gronkhs board",
                    boo.board_follower_count,
                    boo.board_hits_count,
                    boo.session_user_follows,
                    boo.owner_id,
                    boo.topic_id,
                    boo.board_avatar,
                    new Owner(new User(boo.owner_id, "default_user_name", this.bes.getBackendDefaultImageUrl('dummy.png')),
                    [new BoardIdentifier(boo.board_id)]),
                    [new Topic(boo.topics_id,"celebrities", "main")]);
                this.boards2.push(booards)
            });
            //console.log(JsonToXML.parse("url",this.sitemap));


      }))


      this.filteredStates = this.searchValue.valueChanges.pipe(
          // startWith('rfgbhnjm,uoizrewdsdcfvgtbzhnutre'),
          map(board => board ? this._filterStates(board) : this.boards2.slice()));
    }
    private _filterStates(value: string): Board[] {
        const filterValue = value.toLowerCase();
        this.boardLen = this.boardsResults.length - this.boardsResults.filter(board => board.board_name.toLowerCase().indexOf(filterValue)).length;
        return this.boardsResults.filter(board => board.board_name.toLowerCase().indexOf(filterValue) === 0);
    }
    ngOnInit() {
    }

    check(boardname:string){
        this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
        this.router.navigate(["/", boardname]);
        this.hideKeyboard();
    });

    }
    onSubmitSuche(f: NgForm) {
        this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
        this.router.navigate(["/", this.searchValue.value]);
        this.hideKeyboard();
    });
    }
    sendClick(){
    }

    focus(){
      if(this.valuelength >= 0 && this.valuelengthnull == true ){
          this.router.navigate(["search"]);
      }
    }
    changed() {

      this.valuelength = this.value.length;
      if (this.charsLeft <= 40 -1){
          this.charsLeft = 0 + this.value.length + 1  ;

      }
      if(this.valuelength == 2){
          this.router.navigate(["search"]);
          this.valuelengthnull = true;
      }
      if(this.valuelength == 1 ){
          if(this.valuelengthnull == true){
              this._location.back();
          }
      }
      if(this.valuelength == 0){
          this.valuelengthnull = false;
      }
    }
    setvaluetonull(){
      this.charsLeft = 0;
      this._location.back();
      this.valuelengthnull = false;
    }
    hideKeyboard() {
        (document.activeElement as HTMLElement).blur();
    }
    backspace(){
      if (this.charsLeft >= 1){
          this.charsLeft = this.value.length - 1;
      }
      if (this.charsLeft <= 0 ){
      }
    }
    searchbyBoardname(board_name){
        var stringObject = new String( "This is a String Object" );
        stringObject = board_name;
        if(board_name.length >= 0){
            if(stringObject.substring(1,0) == "#"){
                this.boardsResults = []
            }
            else{
                if(board_name.length >= 3){
                    let boardnameWithoutSpace = board_name.replace(/\s/g, "")
                    this.endpointSrv.searchbyBoardnameRequest(boardnameWithoutSpace).subscribe(results=>{
                        this.closeAutoComplete = false;
                        this.boardsResults = results['boards']
                        if(results['boards'].length == 0){
                            this.noBoardFound = true
                        }
                        else{
                            this.noBoardFound = false
                        }
                    })
                }
                else{
                    this.closeAutoComplete = true;
                }

            }
        }
    }
    // getHeroes(): void {
    // this.heroService.getHeroes()
    // .subscribe(heroes => this.heroes = heroes);
    // }
}
